import React from "react";
import useThemeConfig from "src/themes/useThemeConfig";

export default function CategorizedProductsBrowser(props) {
  const config = useThemeConfig();
  const ThemedCategorizedProductsBrowser = config.components.CategorizedProductsBrowser;

  return <ThemedCategorizedProductsBrowser {...props} />;
}
